import { AppTour } from './tour.model';

// Home
import { HOME_TOUR } from './tours/home.tour';

// Manage Employee
import {
  MANAGE_EMPLOYEE_INTRO_TOUR,
  MANAGE_EMPLOYEE_WIZARD_TOUR,
  MANAGE_EMPLOYEE_INVITE_BUTTON_TOUR,
  MANAGE_EMPLOYEE_INVITE_MORE_BUTTON_TOUR,
  INVITE_EMPLOYEE_FORM_TOUR
} from './tours/manage-employee.tour';

// Expense Category
import {
  EXPENSE_CATEGORY_INTRO_TOUR,
  EXPENSE_CATEGORY_WIZARD_TOUR,
  EXPENSE_CATEGORY_ADD_BUTTON_TOUR,
  EXPENSE_CATEGORY_ADD_MORE_BUTTON_TOUR,
  ADD_CATEGORY_PANEL_TOUR
} from './tours/expense-category.tour';

// Mileage
import {
  MILEAGE_WIZARD_TOUR,
  SETUP_MILEAGE_RATE_METHOD_PANEL_TOUR,
  SETUP_MILEAGE_RATE_LIST_TOUR,
  MANAGE_MILEAGE_RATE_PANEL_TOUR
} from './tours/mileage.tour';

// Integrations
import { INTEGRATION_INTRO_TOUR } from './tours/integrations.tour';

// Build Report
import {
  BUILD_REPORT_WIZARD_TOUR,
  BUILD_REPORT_TITLE_DATE_PANEL_TOUR,
  CUSTOMISE_REPORT_PANEL_TOUR
} from './tours/build-report.tour';

// Setup Function
import {
  SETUP_FUNCTION_TOUR,
  SETUP_EXPENSE_CATEGORY_TOUR,
  SETUP_TAX_TOUR,
  SETUP_MILEAGE_TOUR,
  DAILY_LIMIT_POLICY_TOUR,
  REPORT_WRITER_TOUR,
  INTEGRATIONS_TOUR
} from './tours/setup-function.tour';

// Tax Rate
import {
  TAX_RATE_INTRO_TOUR,
  TAX_RATE_WIZARD_TOUR,
  SETUP_TAX_PANEL_TOGGLE_TOUR,
  SETUP_TAX_PANEL_SAVE_TOUR,
  SETUP_TAX_NAME_METHOD_PANEL_TOUR,
  SETUP_TAX_RATES_CODES_PANEL_TOUR,
  ASSIGN_TAX_TO_CATEGORIES_PANEL_TOUR,
  SELECT_TAX_CATEGORY_TOUR,
  ASSIGN_TAX_CATEGORY_TOUR,
  SAVE_TAX_CATEGORY_TOUR
} from './tours/tax-rate.tour';

// Daily Limit Policy
import {
  CAPPING_DAILY_LIMIT_SETUP_TOUR,
  CAPPING_DAILY_LIMIT_DETAILS_CATEGORY_TOUR,
  CAPPING_DAILY_LIMIT_DETAILS_LIMIT_TOUR
} from './tours/daily-limit-policy.tour';

// Profile
import { PROFILE_CLOSE_BUTTON_TOUR } from './tours/profile.tour';

export const TOUR_REGISTRY: Record<string, AppTour> = {
  // Home
  'home': HOME_TOUR,

  // Manage Employee
  'manage-employee-intro-tour': MANAGE_EMPLOYEE_INTRO_TOUR,
  'manage-employee-wizard-tour': MANAGE_EMPLOYEE_WIZARD_TOUR,
  'manage-employee-invite-button-tour': MANAGE_EMPLOYEE_INVITE_BUTTON_TOUR,
  'manage-employee-invite-more-button-tour': MANAGE_EMPLOYEE_INVITE_MORE_BUTTON_TOUR,
  'invite-employee-tour': INVITE_EMPLOYEE_FORM_TOUR,

  // Expense Category
  'expense-category-intro-tour': EXPENSE_CATEGORY_INTRO_TOUR,
  'expense-category-wizard-tour': EXPENSE_CATEGORY_WIZARD_TOUR,
  'expense-category-add-button-tour': EXPENSE_CATEGORY_ADD_BUTTON_TOUR,
  'expense-category-add-more-button-tour': EXPENSE_CATEGORY_ADD_MORE_BUTTON_TOUR,
  'add-category-panel-tour': ADD_CATEGORY_PANEL_TOUR,

  // Mileage
  'mileage-wizard-tour': MILEAGE_WIZARD_TOUR,
  'setup-mileage-rate-method-panel-tour': SETUP_MILEAGE_RATE_METHOD_PANEL_TOUR,
  'setup-mileage-rate-list-tour': SETUP_MILEAGE_RATE_LIST_TOUR,
  'manage-mileage-rate-panel-tour': MANAGE_MILEAGE_RATE_PANEL_TOUR,

  // Integrations
  'integration-intro-tour': INTEGRATION_INTRO_TOUR,

  // Build Report
  'build-report-wizard-tour': BUILD_REPORT_WIZARD_TOUR,
  'build-report-title-date-panel-tour': BUILD_REPORT_TITLE_DATE_PANEL_TOUR,
  'customise-report-panel-tour': CUSTOMISE_REPORT_PANEL_TOUR,

  // Setup Function
  'setup-function-tour': SETUP_FUNCTION_TOUR,
  'setup-tax-tour': SETUP_TAX_TOUR,
  'setup-expense-category-tour': SETUP_EXPENSE_CATEGORY_TOUR,
  'setup-mileage-tour': SETUP_MILEAGE_TOUR,
  'daily-limit-policy-tour': DAILY_LIMIT_POLICY_TOUR,
  'report-writer-tour': REPORT_WRITER_TOUR,
  'integrations-tour': INTEGRATIONS_TOUR,

  // Tax Rate
  'tax-rate-intro-tour': TAX_RATE_INTRO_TOUR,
  'tax-rate-wizard-tour': TAX_RATE_WIZARD_TOUR,
  'setup-tax-panel-toggle-tour': SETUP_TAX_PANEL_TOGGLE_TOUR,
  'setup-tax-panel-save-tour': SETUP_TAX_PANEL_SAVE_TOUR,
  'setup-tax-name-method-panel-tour': SETUP_TAX_NAME_METHOD_PANEL_TOUR,
  'setup-tax-rates-codes-panel-tour': SETUP_TAX_RATES_CODES_PANEL_TOUR,
  'assign-tax-to-categories-panel-tour': ASSIGN_TAX_TO_CATEGORIES_PANEL_TOUR,
  'select-tax-category-tour': SELECT_TAX_CATEGORY_TOUR,
  'assign-tax-category-tour': ASSIGN_TAX_CATEGORY_TOUR,
  'save-tax-category-tour': SAVE_TAX_CATEGORY_TOUR,

  // Daily Limit Policy
  'capping-daily-limit-setup-tour': CAPPING_DAILY_LIMIT_SETUP_TOUR,
  'capping-daily-limit-details-category-tour': CAPPING_DAILY_LIMIT_DETAILS_CATEGORY_TOUR,
  'capping-daily-limit-details-limit-tour': CAPPING_DAILY_LIMIT_DETAILS_LIMIT_TOUR,

  // Profile
  'profile-close-button-tour': PROFILE_CLOSE_BUTTON_TOUR
};